import React from 'react';
import createSVG from '../createSVG';

const DatenschutzIcon = ({style}) => (
  <path style={style} fill='#ffffff' d="m467 512l-422 0c-4 0-8-3-8-8l0-298c0-4 4-7 8-7l422 0c4 0 8 3 8 7l0 298c0 5-4 8-8 8z m-414-15l406 0 0-283-406 0z m328-283c-4 0-7-3-7-8l0-74c0-4 3-8 7-8 5 0 8 4 8 8l0 74c0 5-3 8-8 8z m-248 0c-4 0-8-3-8-8l0-74c0-4 4-8 8-8 4 0 8 4 8 8l0 74c0 5-4 8-8 8z m248-74c-4 0-7-4-7-8 0-64-53-117-117-117-64 0-116 53-116 117 0 4-4 8-8 8-4 0-8-4-8-8 0-73 59-132 132-132 73 0 132 59 132 132 0 4-3 8-8 8z"/>
);

export default createSVG(DatenschutzIcon);
